import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

export const getAll = async (
  fields = [
    'id', 'Descripcion', 'uniCodigo', 'ciudad', 'compania', 'correo', 
    'direccion', 'numContrato', 'ruc', 'telefono', 'urlFirmaSello'
  ]) => {
  const queryFields = fields.join(',');

  const query = `
    query {
      allEstablecimientos {
        ${queryFields}
         personaContacto {
      id
      identificacion
      primerNombre
      primerApellido
    }
      }
    }
  `;

  try {
    const response = await axios.post(rutas.axios + 'api', { query });
    const { data } = response
    return data.data.allEstablecimientos;

  } catch (error) {
    console.error('An error occurred while fetching the options:', error);
    return [];
  }
}


export const getForSelect = async () => {

  const listEstablecimientos = await getAll();
  if (!Array.isArray(listEstablecimientos)) return [];
  return listEstablecimientos.map(item => ({
    value: item.id,
    text : item.Descripcion,
    unicode: item.uniCodigo
  }));

}


export const establecimientosService = {
  getAll,
  getForSelect
}
